import styled from 'styled-components';

const ChatStepContainer = styled.div`
`;

export default ChatStepContainer;
